import * as React from 'react';
import Modal from "react-responsive-modal";
import UsersGrid from "../../bo-core/grids/UsersGrid/UsersGrid";
import GroupsGrid from "../../bo-core/grids/GroupsGrid/GroupsGrid";
import './accessControlModal.css'
import {ReactNode} from "react";
import FunctionalitiesGrid from "../../bo-core/grids/FunctionalitiesGrid/FunctionalitiesGrid";

interface State {
    gridApi: boolean;
    columnApi: boolean;
    columnDefs: any;
}
interface Props {
    modalTitle: string
    showModal: boolean;
    modalFuncInfo?: any;
    modalUserInfo?: any;
    modalGroupInfo?: any;
    gridType: GridType;
    access?: Access;
    roles?: any;
    closeModal(): void;
}

export enum GridType {
    USERS = 'Users',
    GROUPS = 'Groups',
    FUNCTIONALITIES = 'Functionalities'
}

export enum Access {
    ALLOWED = 'Allowed',
    DENIED = 'Denied'
}

class AccessControlModal extends React.Component<Props, State>  {
    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [],
            gridApi: null,
            columnApi: null,
        };
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {

    }

    close = () => {
        this.props.closeModal();
    }

    renderGrid = (): ReactNode => {
        if (this.props.gridType !== null && this.props.gridType === GridType.USERS) {
            return <UsersGrid renderInModal={true}
                              funcId={this.props.modalFuncInfo ? this.props.modalFuncInfo.id : null}
                              access={this.props.access ? this.props.access : null}
                              role={this.props.roles ? this.props.roles[0] : null}/>
        } else if (this.props.gridType !== null && this.props.gridType === GridType.GROUPS) {
            return  <GroupsGrid renderInModal={true}
                                funcId={this.props.modalFuncInfo ? this.props.modalFuncInfo.id : null}
                                access={this.props.access ? this.props.access : null}/>
        } else if (this.props.gridType !== null && this.props.gridType === GridType.FUNCTIONALITIES) {
            return <FunctionalitiesGrid renderInModal={true}
                                        userId={this.props.modalUserInfo ? this.props.modalUserInfo.id : null}
                                        groupId={this.props.modalGroupInfo ? this.props.modalGroupInfo.id : null}
                                        access={this.props.access}/>
        }
    }

    render() {
        return (
            <Modal
                open={this.props.showModal}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: this.props.gridType === GridType.GROUPS ? '45%' : '70%',
                        padding: 0,
                        maxWidth: this.props.gridType === GridType.GROUPS ? '45%' : '70%',
                    }
                }}
                closeOnEsc={true}
                onClose={this.close}
                center
                focusTrapped={true}
                closeOnOverlayClick={false}
            >
                <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}}>
                    <div className="row" style={{height: '100%'}}>
                        <div id={'create-user-container'} className='col-lg-12 compare-changes'>
                            <header className={'role-info-modal-header'}>
                                <h2>{this.props.modalTitle}</h2>
                            </header>
                            <div className={'role-info-modal-container'}>
                                <div style={{width: '100%'}}>
                                    {this.renderGrid()}
                                </div>
                            </div>
                            <footer style={{
                                background: "#2D3436",
                                borderTop: "2px solid #f5f5f5a3",
                                height: 49,
                                width: "100%",
                                paddingRight: 5,
                                paddingTop: 3,
                            }}>
                                <button
                                    onClick={this.close}
                                    className={"btn"}
                                    style={{float: "right", marginTop: 3, marginRight: 2}}>
                                    <i className="fas fa-times"> Close</i>
                                </button>
                            </footer>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
export default AccessControlModal



// WEBPACK FOOTER //
// ./app/components/common/AccessControlModal/AccessControlModal.tsx